import { AlterarSenha } from "./AlterarSenha";

export default AlterarSenha;